import { type CustomFieldSchema } from '@tribeplatform/gql-client/types'
import { noop } from '@tribeplatform/react-ui-kit/hooks'
import { type IconSize, SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { CustomFieldSubtype } from '../../CustomField/utils.js'
import { getFieldSetting } from '../utils/utils.js'

import { FieldTypeIcon } from './FieldTypeIcon.js'

interface Props {
  field: CustomFieldSchema
  size?: IconSize
}

export const FieldSubTypeIcon = ({ field, size = 'md' }: Props) => {
  const { type } = field
  const subType = getFieldSetting<CustomFieldSubtype>(field, 'subtype')

  if (subType) {
    switch (subType) {
      case CustomFieldSubtype.CHECKBOX:
        return <SvgIcon name="check" size={size} />
      case CustomFieldSubtype.DATE:
        return <SvgIcon name="calendar" size={size} />
      case CustomFieldSubtype.DATETIME:
        return <SvgIcon name="clock" size={size} />
      case CustomFieldSubtype.EMAIL:
        return <SvgIcon name="at-symbol" size={size} />
      case CustomFieldSubtype.FILE:
        return <SvgIcon name="attachment" size={size} />
      case CustomFieldSubtype.FILES:
        return <SvgIcon name="attachment" size={size} />
      case CustomFieldSubtype.HTML:
        return <SvgIcon name="post" size={size} />
      case CustomFieldSubtype.IMAGE:
        return <SvgIcon name="image" size={size} />
      case CustomFieldSubtype.IMAGES:
        return <SvgIcon name="image" size={size} />
      case CustomFieldSubtype.MEMBER:
        return <SvgIcon name="member" size={size} />
      case CustomFieldSubtype.MEMBERS:
        return <SvgIcon name="members" size={size} />
      case CustomFieldSubtype.MULTISELECT:
        return <SvgIcon name="selector" size={size} />
      case CustomFieldSubtype.NUMBER:
        return <SvgIcon name="hash" size={size} />
      case CustomFieldSubtype.POST:
        return <SvgIcon name="post" size={size} />
      case CustomFieldSubtype.POSTS:
        return <SvgIcon name="post" size={size} />
      case CustomFieldSubtype.RATING:
        return <SvgIcon name="star" size={size} />
      case CustomFieldSubtype.SELECT:
        return <SvgIcon name="selector" size={size} />
      case CustomFieldSubtype.SPACE:
        return <SvgIcon name="grid" size={size} />
      case CustomFieldSubtype.SPACES:
        return <SvgIcon name="grid" size={size} />
      case CustomFieldSubtype.TAG:
        return <SvgIcon name="tag" size={size} />
      case CustomFieldSubtype.TAGS:
        return <SvgIcon name="tag" size={size} />
      case CustomFieldSubtype.TEXT:
        return <SvgIcon name="field-text" size={size} />
      case CustomFieldSubtype.TEXTAREA:
        return <SvgIcon name="field-text" size={size} />
      case CustomFieldSubtype.TOGGLE:
        return <SvgIcon name="status-success" size={size} />
      case CustomFieldSubtype.URL:
        return <SvgIcon name="link" size={size} />
      default: {
        // Code should never reach the default case
        const exhaustiveCheck: never = subType
        noop(exhaustiveCheck)
        return null
      }
    }
  }

  return <FieldTypeIcon type={type} size={size} />
}
